//var jq223=jQuery.noConflict(!0),$=jq223;
window.addEventListener("DOMContentLoaded", function () {
  (function ($) {
    "use strict";
    //console.log("(hb_racquet-customizer.js) loaded");
    const productJSON = getProductJson();
    const productVariants = getProductVariants(productJSON);
    const $customizerLink = $('a[class*="customize-item-link"]');
    if ($customizerLink.length == 0) {
      return;
    }
    const $addCustomToCartButton = $('button[id^="AddCustomToCart-"]');
    const $addCustomText = $('span[id^="AddCustomToCartText-"]');
    const $AddToCartButton = $('button[id^="AddToCart-"]');
    const base_url = $customizerLink.attr("href").substring(0, $customizerLink.attr("href").length - 2);
    const $sizeSelect = $('select.product-form__single-selector[name="Size"]');
    const $stringSelect = $('#stringing-selection');
    const $sizeRadios = $('div[name="Size"]');
    
    function get_data_sizecode() {
      //console.log("(hb_racquet-customizer.js) get_data_sizecode()");
      let size_code = "";
      if ($sizeSelect.length) {
        size_code = $sizeSelect.find(':selected').data('sizecode');
      } else {
        //console.log('select[data-name="Size"] not found, options are not set to dropdowns');
        if ($sizeRadios.html().length > 1) {
          //console.log('fieldset.single-option-radio[name="Size"] found, options are set to buttons');
          size_code = $sizeRadios.find(':checked').data('sizecode');
          //console.log('found active size_code: '+size_code);
        } else {
          //console.log('fieldset.single-option-radio[name="Size"] not found, options are not set to buttons');
          return false;
        }
      }
      return size_code;
    }

    function get_string_op() {
        //console.log("(hb_racquet-customizer.js) get_string_op()");
        let string_op = "";
        if ($stringSelect.length) {
            string_op = 'string=' + $stringSelect.find(':selected')[0].value;
        }
        return string_op;
    }

    function get_raw_sizecode() {
      //console.log("(hb_racquet-customizer.js) get_raw_sizecode()");
      let size_code = "";
      if ($sizeSelect.length) {
        size_code = $sizeSelect.find(':selected').val();
      } else {
        //console.log('select[data-name="Size"] not found, options are not set to dropdowns');
        if ($sizeRadios.html().length > 1) {
          //console.log('fieldset.single-option-radio[name="Size"] found, options are set to buttons');
          size_code = $sizeRadios.find(':checked').val();
          //console.log('found active size_code: '+size_code);
        } else {
          //console.log('fieldset.single-option-radio[name="Size"] not found, options are not set to buttons');
          return false;
        }
      }
      return size_code;
    }

    function getProductJson() {
      const $template = $('div[id^="ProductSection-"]');
      const sectionId = $template.data('section-id');
      const JSONscript = $('script[id^="ProductJson-"]');
      if (!JSONscript.html()) {
        return false;
      } else {
        return JSON.parse(JSONscript.html());
      }
    }
    
    function getProductVariants(p) {
      const product = p;
      //console.log(JSON.stringify(p));
      if (product.hasOwnProperty('variants')) {
        return product.variants;
      } else {
        return false
      }
    }
    
    function isAvailable(p) {
      const product = p;
      if (product.hasOwnProperty('available')) {
        return product.available;
      } else {
        return false
      }
    }
    
    function strip_size_code(s) {
      return s.substring(s.indexOf(' ') + 1).trim();
    }
    
    function main() {
      let size_code = get_data_sizecode();
      let string_op = get_string_op();
      if (size_is_demo(size_code)) {
        size_code = convert_demo_text(size_code);
      }

      for (let i in productVariants) {
        const variant = productVariants[i];
        if (size_code === strip_size_code(variant.sku)) {
          if (size_is_demo(size_code) || !isAvailable(variant)) {
            clear_customizer_link();
            $addCustomToCartButton.hide();
            $customizerLink.hide();
            $AddToCartButton.show();
          } else {
            set_customizer_link(size_code, string_op);
            $customizerLink.show();
            $addCustomToCartButton.show();
            $AddToCartButton.hide();
          }
          break;
        }
      }
    }
    
    function set_customizer_link(size, string_op) {
      //console.log('setting customizer link: '+base_url + size);
      if ($customizerLink.hasClass('disabled')) {
        $customizerLink.removeClass('disabled');
        $addCustomToCartButton.removeClass('disabled');
        $addCustomToCartButton.removeAttr('disabled');
        $addCustomText.text('Select Stringing Options');
      }
      $customizerLink.attr("href", base_url + size + "&" + string_op);
    }
    
    function clear_customizer_link() {
      //console.log('clearing customizer link');
      $customizerLink.attr("href", '');
    }
    
    function size_is_demo(code) {
      //console.log("size_is_demo("+code+")");
      if (!code) return false;
      if (code.charAt(0) === "D") {
        return true
      }
      return false;
    }
    
    // convert from "demo" to the D-- format
    function convert_demo_text(code) {
      if (code === "Demo") {
        //console.log("convert_demo_text("+code+")");
        const val = get_raw_sizecode();
        let val_split = val.split(" ");
        const demo_code = val_split[0].charAt(0) + val_split[1];
        //console.log("val: "+val+" -> "+demo_code);
        return demo_code;
      } else {
        return code;
      }
    }
    
    $sizeSelect.on('change', function () {
      main();
    });
    
    $('input[name="Size"][type="radio"]').on('change', function () {
      main();
    });
    $customizerLink.magnificPopup({
      type: 'ajax',
      closeOnContentClick: false,
      closeOnBgClick: true,
      showCloseBtn: true,
      closeMarkup: '<button title="%title%" type="button" class="hb_row-1 hb_col-1 mfp-close">&#215;</button>',
      callbacks: {
        open: function() {},
        close: function() {},
        updateStatus: function(data) {
          if (data.status == 'ready') {
            openedMFP();
          }
        }
        // e.t.c.
      },
      disableOn: function() {
        let $customizerLinkCheck = $('a[class*="customize-item-link"]');
        if($customizerLinkCheck.length) {
          return true;
        }
        return false;
      }
    });
    
    $(document).ready(function () {
      
      main();
    });
    
  })(jq223);
});